import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { VanMovelData } from '@/app/interface/vanMovel';
import { getVanMovelData } from '@/app/services/vanMovel';
import { formatDateTime } from '@/app/utils/dateFormat';

const VanMovel = () => {
  const [vanMovelData, setVanMovelData] = useState<VanMovelData[]>([]);
  const [selectedLoja, setSelectedLoja] = useState<VanMovelData | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getVanMovelData(9);
      setVanMovelData(response.data);
      if (response.data.length > 0) {
        setSelectedLoja(response.data[0]);
      }
    };

    fetchData();
  }, []);

  if (!selectedLoja || vanMovelData.length === 0) return null;

  return (
    <section className="w-full bg-white py-16">
      <div className="container mx-auto flex items-center gap-16">
        <div className="">
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/van-movel/van-movel.png"
            alt="Oficina Móvel Toyota"
            width={600}
            height={100}
            className="rounded-lg object-cover"
          />
        </div>
        <div className="w-1/2">
          <h2 className="text-4xl font-toyota-display mb-6 text-black">Oficina Móvel Kyoto</h2>
          <p className="font-toyota-text text-black mb-4">
            A qualidade Toyota mais perto de você!
          </p>
          <p className="font-toyota-text text-black mb-8">
              A manutenção do seu Toyota ficou ainda mais fácil! Com a Oficina Móvel Kyoto, realizamos revisões, recalls e pequenos reparos diretamente na sua cidade.
              Confira o cronograma e agende seu atendimento clicando no botão abaixo. Os atendimentos são limitados e feitos apenas com agendamento antecipado.
          </p>
          
          <div className="mb-8">
            {vanMovelData.length > 1 ? (
              <div className="relative">
                <select
                  value={selectedLoja.id}
                  onChange={(e) => {
                    const selected = vanMovelData.find(loja => loja.id === Number(e.target.value));
                    if (selected) setSelectedLoja(selected);
                  }}
                  className="w-full mb-4 px-4 py-2 rounded-2 font-toyota-text text-black bg-gray-100 appearance-none cursor-pointer"
                >
                  {vanMovelData.map(loja => (
                    <option key={loja.id} value={loja.id}>
                      {loja.nome_loja}
                    </option>
                  ))}
                </select>
                <div className="absolute right-3 top-[13px] pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="11" viewBox="0 0 5 11" fill="none">
                    <path d="M0 10.75L5 5.75L0 0.75V10.75Z" fill="#1A1A1A"/>
                  </svg>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between w-full mb-4 bg-gray-100 px-4 py-2 rounded-2">
                <span className="font-toyota-text text-black">{selectedLoja.nome_loja}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="11" viewBox="0 0 5 11" fill="none">
                  <path d="M0 10.75L5 5.75L0 0.75V10.75Z" fill="#1A1A1A"/>
                </svg>
              </div>
            )}
            <h3 className="text-xl font-toyota-display mb-4 text-black" style={{ fontFamily: 'Toyota Type Bold' }}>{selectedLoja.nome_estabelecimento}</h3>
            <p className="font-toyota-text text-black">{selectedLoja.endereco_loja}</p>
            <p className="font-toyota-text text-black">
              Data: {formatDateTime(selectedLoja.data_inicio)} - {formatDateTime(selectedLoja.data_fim)}
            </p>
          </div>

          <Link 
            href="https://api.whatsapp.com/send/?phone=556130032626&text=Olá! Gostaria de saber mais informações sobre a Van Móvel da Toyota."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-black px-8 py-3 rounded border border-black hover:bg-black hover:text-white transition-colors"
          >
            FAÇA SEU AGENDAMENTO
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VanMovel;